import home from './home'
import comment from './comment'
import address from './address'
import confirm from './confirm'
import order from './order'
import user from './user'
import orderList from './order_list'
import entering from './entering'
import worker from './worker'
import collect from './collect'
import category from './category'
import common from './common'
import product from './product'
import spuList from './spuList'
import groupBuy from './groupBuy'
import serviceLog from './serviceLog'
import recovery from './recovery'

export default {
  ...home,
  ...comment,
  ...address,
  ...confirm,
  ...order,
  ...user,
  ...orderList,
  ...entering,
  ...worker,
  ...collect,
  ...category,
  ...common,
  ...product,
  ...spuList,
  ...groupBuy,
  ...serviceLog,
  ...recovery
}
